export default __webpack_public_path__ + "static/media/schedule.5823bd8e.svg";